import { makeStyles } from 'tss-react/mui';
export const useStyles = makeStyles()((theme) => ({
    InputErrorMessage: {
        color: theme.palette.error.main,
        marginTop: '8px',
        display: 'block'
    }
}));
//# sourceMappingURL=styles.js.map